import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import dayjs, { Dayjs } from 'dayjs';

import Icons from '../../../../themes/icons';
import Button from '../../../Button/Button';
import DateCalendar from '../../../Dialogs/CreateInvite/components/DateCalendar';
import TimeRangePicker from '../../../Dialogs/CreateInvite/components/TimeRangePicker';
import { useCreateInvite } from '../../../Dialogs/CreateInvite/context/CreateInvite.context';

function isEndTimeValidHandle(startTime?: Dayjs, endTime?: Dayjs) {
  return endTime?.isAfter(startTime);
}

export const Step2 = () => {
  const { state, dispatch } = useCreateInvite();

  const currentDate = dayjs();

  const maxEndTimeForCollabOffer = currentDate.add(2, 'hours');

  const isCurrentDateFound = state.dates
    ? state.dates.every((date) => currentDate.isSame(date, 'day'))
    : false;

  const isStartTimeMustLeastAfterOneHour = React.useMemo(
    () => isCurrentDateFound && currentDate.isAfter(state.startTime),
    [isCurrentDateFound, currentDate, state.startTime],
  );

  const isEndTimeMustLeastAfterTwoHour = React.useMemo(
    () => isCurrentDateFound && maxEndTimeForCollabOffer.isAfter(state.endTime),
    [isCurrentDateFound, maxEndTimeForCollabOffer, state.endTime],
  );

  const isEndTimeValid = React.useMemo(
    () => !isEndTimeValidHandle(state.startTime, state.endTime),
    [state.endTime, state.startTime],
  );

  const onBack = () => {
    dispatch({ type: 'prev' });
  };

  return (
    <Box>
      <Box
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
        sx={{ borderBottom: '1px solid #F1F2F1', backgroundColor: '#FCFCFC', px: 5, py: 3 }}
      >
        <Box display={'flex'} alignItems={'center'} gap={1.5}>
          <Button startIcon={<Icons.BackIcon />} onClick={onBack} />
          <Typography fontWeight={'500'} sx={{ fontFamily: 'Poppins', fontSize: '18px' }}>
            Select dates
          </Typography>
        </Box>
      </Box>
      <Box sx={{ backgroundColor: '#FCFCFC', px: 5, py: 3 }}>
        <Box maxWidth={'85%'}>
          <Stack spacing={3}>
            <Box
              display={'flex'}
              alignItems={'center'}
              gap={'22px'}
              sx={{ border: '1px solid #F1F2F1', borderRadius: '8px', p: 1.5 }}
              maxWidth={'100%'}
            >
              <Icons.InfoLightIcon />
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: '15px',
                }}
              >
                Select dates for your invitation, members will be able to{' '}
                <b>reserve only one date</b>
              </Typography>
            </Box>
            <Box>
              <DateCalendar
                sx={{
                  width: '100%',
                  '& .MuiDayCalendar-header': {
                    justifyContent: 'space-evenly',
                  },
                  '& .MuiDayCalendar-weekDayLabel': {
                    fontWeight: 500,
                  },
                  '& .MuiDayCalendar-weekContainer': {
                    justifyContent: 'space-evenly',
                  },
                }}
                defaultValue={state.dates}
                onChange={(value) => {
                  const isCurrentDateFound = value
                    ? value.some((date) => currentDate.isSame(date, 'day'))
                    : false;
                  if (isCurrentDateFound) {
                    const currentTime = dayjs();
                    const remainder = currentTime.minute() % 5;
                    const minutesToAdd = remainder === 0 ? 5 : 5 - remainder;
                    const startTime = currentTime.add(minutesToAdd, 'minute');

                    dispatch({
                      type: 'update',
                      payload: {
                        dates: value ?? undefined,
                        startTime,
                        endTime: startTime.add(2, 'hours'),
                      },
                    });
                  } else {
                    dispatch({
                      type: 'update',
                      payload: { dates: value ?? undefined },
                    });
                  }
                }}
              />
            </Box>
          </Stack>

          <Box display='flex' justifyContent='space-between' alignItems='flex-end' marginTop={4}>
            <TimeRangePicker
              startTime={state.startTime}
              endTime={state.endTime}
              onChange={(payload) => {
                dispatch({ type: 'update', payload });
              }}
              shouldDisaledThePreviousTime={isCurrentDateFound}
              isStartTimeMustLeastAfterOneHour={isStartTimeMustLeastAfterOneHour}
              isEndTimeMustLeastAfterTwoHour={isEndTimeMustLeastAfterTwoHour}
              isEndTimeValid={isEndTimeValid}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
